import { CircularProgress } from "@material-ui/core";
import React from "react";

const FullScreenProgress: React.FC = () => {
	return (
		<>
            <div className="sweet-loading" style={{
                position: "absolute",
                top: "40%",
                left: "50%",
                marginTop: "-20px",
                marginLeft: "-20px",
                width: "40px",
                height: "40px",
                zIndex: 2,
            }}>
                <CircularProgress />
            </div>
		</>
	);
};

export default FullScreenProgress;
